module.exports = __webpack_public_path__ + "d862df975ed1e193f6a3ed08c2c77f2c.png";